import { defectStatisRequest } from '@/network/requests/defectStatis'
import { modelRequest } from '@/network/requests/model'
import { modelSideRequest } from '@/network/requests/modelSide'
import { modelSideImageRequest, getModelSideImageUrlByFileId } from '@/network/requests/modelSideImage'
import { getDefectRequest, getDefectImageUrlByMd5 } from '@/network/requests/defect'
import { jtInfoRequest, getJTIdNameMap } from '@/network/requests/jtInfo'
import { productRequest } from '@/network/requests/product'
import { defectTypeRequest } from '@/network/requests/defectType'
import defectService from '@/service/defectService'

/**
 * 缺陷浏览器状态共享类。
 */
export const store = {
	/**
	 * 是否进行调试。
	 */
	debug: true,
	/**
	 * 图像偏移量。
	 */
	offset: -143,
	/**
	 * 缺陷记录筛选条件。
	 */
	filter: {
		/**
		 * 检测面。
		 */
		side_index: -1,
		/**
		 * 选择缺陷区域
		 */
		selectionArea: [],
		/**
		 * 缺陷类型。
		 */
		type: -1,
		/**
		 * 缺陷状态。
		 */
		status: '',
		/**
		 * 是否查询标记码
		 */
		checkMark: false,
		/**
		 * 标记内容。
		 */
		markValue: '',
	},
	state: {
		message: '',

		/**
		 * 产品Id。
		 */
		productId: '',
		/**
		 * 产品名称
		 */
		productName: '',
		/**
		 * 产品信息。
		 */
		productInfo: {},
		/**
		 * 机台名称。
		 */
		jtName: '',
		/**
		 * 批次信息。
		 */
		batchInfo: null,
		/**
		 * 批次Id。
		 */
		batchId: '',
		/**
		 * 批次名称。
		 */
		rollCode: '',
		/**
		 * 版面集合。
		 */
		surfacelist: [],
		/**
		 * 批次长度。
		 */
		totalLength: 0,
		/**
		 * 版面。
		 */
		modelSides: [],
		/**
		 * 版面图片。
		 */
		modelSideImages: [],
		/**
		 * 当前版面图索引。
		 */
		modelSideIndex: 0,
		/**
		 * 缺陷记录。
		 */
		defects: [],
		/**
		 * 过滤后的缺陷记录。
		 */
		filteredDefects: [],
		/**
		 * 缺陷类型。
		 */
		defectTypes: [],
		/**
		 * 缺陷标记。
		 */
		defectSign: [],
		/**
		 * 缺陷记录是否加载完成。
		 */
		defectDataLoaded: false,
		/**
		 * 缺陷点记录。
		 */
		pointsData: [],
		/**
		 * 当前选中缺陷记录。
		 */
		selectedDefectId: '',
		/**
		 * 版图base64字符串。
		 */
		originalImageBase64: '',
		/**
		 * 标尺显示状态。
		 */
		ruleBarVisible: true,
		/**
		 * 缺陷点显示状态。
		 */
		defectPointVisible: false,
		/**
		 * 选中缺陷点的对应的版图抠图。
		 */
		defectCutoutImage: false,
		/**
		 * 密度点，圆的半径，默认=2
		 */
		pointRadius: 2,
		/**
		 * 筛选状态。
		 */
		filterStatus: 0,
		/**
		 * 当前用户角色。
		 */
		roles: [],
		/**
		 * 当前角色是否是质检。
		 */
		isQA: false,
		/**
		 * 当前用户信息。
		 */
		userInfo: {},
	},
	/**
	 * 获取批次信息。
	 */
	async getBatchInfo() {
		if (this.debug) console.log('获取批次信息')
		var batchInfo = (await defectStatisRequest.getDocumentById(this.state.batchId)).data

		console.log('batchInfo', batchInfo)

		//获取批次信息。
		this.state.batchInfo = batchInfo
		this.state.totalLength = batchInfo.total_len / 1000
		this.state.rollCode = batchInfo.roll_code
		this.state.filterStatus = batchInfo.filter_status

		console.log(this.state.batchInfo)
	},

	/**
	 * 获取模板。
	 */
	async getRollModel() {
		if (this.debug) console.log('获取模板')

		//获取批次所有的模板。
		var model = (await modelRequest.queryAll({ roll_id: this.state.batchId }))[0]

		if (model) {
			//检测面。
			this.state.modelSides = await modelSideRequest.queryAll({ model_id: model._id.$oid }, undefined, { side_index: 1 })
			//检测面图片。
			this.state.modelSideImages = await modelSideImageRequest.queryAll({ model_id: model._id.$oid })

			var side_index = this.state.modelSides[0].side_index

			//设置版面图。
			this.setModelSideIndex(side_index)
		}
	},

	/**
	 * 切换版图。
	 * @param {*} value
	 */
	async changeSurface(value) {
		if (this.debug) console.log('切换版图')
		//取得检测面。
		var md = this.state.modelSides.find(t => t.side_index == value)
		if (!md) {
			return
		}

		//查询检测面的图片。
		var msi = this.state.modelSideImages.find(t => t.model_side_id == md._id.$oid)
		if (msi) {
			//获取版图的 restHeart 的blob。
			var imgBase64 = await getModelSideImageUrlByFileId(msi.file_id)

			this.state.originalImageBase64 = imgBase64 // window.location.protocol + '//' + window.location.host + url

			//如果当前选中缺陷记录不在当前结果集中，设置默认第一个缺陷记录选中。
			var existIndex = this.state.filteredDefects.findIndex(t => t._id.$oid == this.state.selectedDefectId)
			if (existIndex == -1) {
				if (this.state.filteredDefects.length > 0) {
					this.state.selectedDefectId = this.state.filteredDefects[0]._id.$oid
				}
			}
		}
	},

	/**
	 * 加载所有缺陷记录。
	 */
	async loadDefects() {
		this.state.defectDataLoaded = false
		if (this.debug) console.log('加载所有缺陷记录')

		var items = []
		//获取所有缺陷信息。--{ side_index: side_index }
		var array = await getDefectRequest(this.state.batchId).queryAll(undefined, undefined, { side_index: 1 }, 1000)

		array.forEach(element => {
			var p = { ...element }

			//减去偏移量。
			p.pos_x = p.pos_x + this.offset

			items.push(p)
		})

		this.state.defects = items
		this.state.filteredDefects = items
		this.state.defectSign = items
			.map(p => p.meter / 1000)
			.sort((a, b) => {
				return a - b
			})

		this.state.pointsData = items.map(p => {
			return {
				id: p._id.$oid,
				x: p.pos_x + p.size_cx / 2,
				y: p.pos_y + p.size_cy / 2,
			}
		})

		setTimeout(() => {
			this.state.defectDataLoaded = true
		}, 1000)
	},

	/**
	 * 获取机台信息。
	 * @param {*} jtId
	 */
	async getJTInfo(jtId) {
		//
		jtId = this.state.batchInfo.jt_id
		if (this.debug) console.log('获取机台信息', jtId)

		var jtName = (await getJTIdNameMap(jtId)).get(jtId)
		this.state.jtName = jtName
	},

	/**
	 * 获取产品信息。
	 */
	async getProductInfo() {
		var productId = this.state.batchInfo.product_id

		if (this.debug) console.log('获取产品信息', productId)
		productRequest.getDocumentById(productId).then(res => {
			this.state.productInfo = res.data
			this.state.productName = res.data.name
			this.state.productId = res.data._id.$oid
		})
	},

	/**
	 * 获取缺陷类型。
	 */
	async getDefectTypes() {
		if (this.debug) console.log('获取缺陷类型')
		defectTypeRequest.queryAll({ roll_id: this.state.batchId }).then(res => {
			this.state.defectTypes = res
		})
	},

	/**
	 * 获取缺陷筛选条件，可用于 List.filter(【参数】)。
	 * @param {*} item  缺陷记录对象。
	 */
	getFilter(item) {
		var result = true

		//条件：缺陷状态。
		if (this.filter.status == 'good') {
			result = item.status == 1
		} else if (this.filter.status == 'bad') {
			result = item.status == 0
		}

		//条件：缺陷类型。
		if (this.filter.type > -1) {
			result &= item.type_index == this.filter.type
		}

		//条件：标记查询。
		if (this.filter.checkMark) {
			result &= item.remark == this.filter.markValue
		}

		//条件：选中区域。
		var sectionArea = this.filter.selectionArea
		if (sectionArea[0] && sectionArea[1] && sectionArea[2] && sectionArea[3]) {
			var x1 = parseFloat(sectionArea[0])
			var y1 = parseFloat(sectionArea[1])
			var x2 = parseFloat(sectionArea[2])
			var y2 = parseFloat(sectionArea[3])
			result &= item.pos_x > x1 && item.pos_x < x2
			result &= item.pos_y > y1 && item.pos_y < y2
		}

		//条件：检测面。
		if (this.filter.side_index > -1) {
			result &= item.side_index == this.filter.side_index
		}

		return result
	},

	/**
	 * 修改筛选状态。
	 * @param {*} val 筛选状态值。
	 */
	changeFilterStatus(val) {
		if (this.debug) console.log('changeFilterStatus 修改筛选状态', val)

		if (this.state.batchInfo.filter_status == val) {
			if (this.debug) console.log('状态相同，跳过筛选状态的修改。', val)
			return
		}

		console.log('this.userInfo', this.state.userInfo)

		if (!this.state.userInfo.id) {
			alert('登录超时,请重新登录')
			return
		}

		//修改筛选状态，并且设置筛查员。
		this.state.batchInfo.filter_status = val
		var updateObject = {
			filter_status: val,
			filter_time: {
				$date: new Date().getTime(),
			},
			filter_operator_id: this.state.userInfo.id,
		}

		//如果是修改完成状态，需要对数据进行统计。
		if (val == 2) {
			var qaData = this.getDefectQADataStat()
			Object.assign(updateObject, qaData)
		}

		//设置筛选状态。
		this.state.filterStatus = val
		defectStatisRequest.modifyById(this.state.batchId, updateObject)
	},

	/**
	 *  获取筛选状态文本。
	 * @param {*} status
	 */
	getFilterStatusText(status) {
		if (status == 0) {
			return '未筛选'
		} else if (status == 1) {
			//进行时间的插入filter_time
			return '正在筛选'
		}

		return defectService.getFilterStatusText(this.state.batchInfo.filter_status)
	},

	/**
	 * 获取坏品个数。
	 */
	getBadCount() {
		return this.state.defects.filter(t => t.status == 0).length
	},

	/**
	 * 获取好品个数。
	 */
	getGoodCount() {
		return this.state.defects.filter(t => t.status == 1).length
	},

	/**
	 * 获取坏品张号集合。
	 */
	getBadSheets() {
		var array = this.state.defects.filter(t => t.status == 0)

		var sheets = []
		array.forEach(item => {
			if (sheets.indexOf(item.sheet_index) == -1) {
				sheets.push(item.sheet_index)
			}
		})

		return sheets
	},

	/**
	 * 获取质检统计数据。
	 */
	getDefectQADataStat() {
		var batchInfo = this.state.batchInfo

		//单个缺陷长度。
		var singleDefectLen = batchInfo.total_len / batchInfo.Insp_count

		var badCount = this.getBadCount()
		//var goodCount = this.getGoodCount()

		//坏品张数量。
		var badSheetCount = this.getBadSheets().length

		//印刷缺陷长度
		var bad_len_printer = parseInt((badCount * singleDefectLen).toFixed(0))
		//QA确认缺陷长度
		var bad_len_qa = parseInt((badSheetCount * singleDefectLen).toFixed(0))
		//QA调整缺陷长度(当前确认缺陷长度-上一次QA确认缺陷长度)
		var bad_Len_qa_judgement = bad_len_qa - batchInfo.bad_len_qa

		console.log('batchInfo', batchInfo)
		console.log('QA确认缺陷长度', bad_len_qa)
		console.log('QA调整缺陷长度', bad_len_qa - batchInfo.bad_len_qa)

		return {
			bad_len_printer,
			bad_len_qa,
			bad_Len_qa_judgement,
		}
	},

	/**
	 * 设置标尺显示状态。
	 * @param {*} visible
	 */
	setRuleBarVisible(visible) {
		if (this.debug) console.log('setRuleBarVisible', visible)
		this.state.ruleBarVisible = visible
	},

	/**
	 * 设置缺陷点显示状态。
	 * @param {*} visible
	 */
	setDefectPointVisible(visible) {
		if (this.debug) console.log('setDefectPointVisible', visible)
		this.state.defectPointVisible = visible
	},

	/**
	 * 设置版面图的索引值。
	 * @param {*} index
	 */
	setModelSideIndex(index) {
		if (this.debug) console.log('setModelSideIndex', index)
		this.state.modelSideIndex = index

		this.changeSurface(index)
	},

	/**
	 * 设置当前选中的缺陷记录。
	 * @param {*} val 记录Id
	 */
	setSelectedDefectId(val) {
		if (this.debug) console.log('setSelectedDefectId', val)
		this.state.selectedDefectId = val

		//如果选中的缺陷记录版图有变化则切换版图。
		var defectInfo = this.state.defects.find(t => t._id.$oid == val)
		if (defectInfo != null) {
			if (defectInfo.side_index != this.state.modelSideIndex) {
				this.setModelSideIndex(defectInfo.side_index)
			}
		}
	},

	/**
	 * 获取缺陷记录信息
	 * @param {*} id 缺陷记录Id。
	 */
	getDefectInfo(id) {
		var item = this.state.defects.find(t => t._id.$oid == id)
		if (!item) {
			console.error(`没有找到缺陷记录，缺陷Id：${id}`)
		}

		return item
	},

	/**
	 * 获取缺陷点的图片。
	 * @param {*} id
	 */
	async getDefectImage(id) {
		var defectInfo = this.getDefectInfo(id)
		var img = await getDefectImageUrlByMd5(defectInfo.md5, this.state.batchId)
		return img
	},

	/**
	 * 获取条件过滤后的缺陷点记录。
	 */
	getFilteredDefects() {
		var data = this.state.defects.filter(t => this.getFilter(t))

		return data
	},

	/**
	 * 设置版图中的缺陷记录抠图图片。
	 * @param {*} dataURL
	 */
	setSelectedDefectCutoutImage(dataURL) {
		this.state.defectCutoutImage = dataURL
	},

	/**
	 * 设置密度点圆的半径。
	 * @param {*} radius
	 */
	setPointRadius(radius) {
		this.state.pointRadius = radius
	},

	/**
	 * 设置过滤条件。
	 */
	setFilter(filter) {
		//进行对象合并。
		Object.assign(this.filter, filter)

		if (this.debug) console.log('setFilter', this.filter)

		//进行筛选记录过滤。
		this.state.filteredDefects = this.state.defects.filter(t => this.getFilter(t))
	},

	/**
	 * 缺陷记录全选。
	 * @param {*} checked
	 */
	setDefectsSelected(checked) {
		this.state.filteredDefects.forEach(item => {
			item.checked = checked
		})
	},

	/**
	 * 设置缺陷记录状态（好品，坏品）
	 * @param {*} status 1=好品，0=坏品。
	 */
	setDefectsStatus(status) {
		//如果不是质检，禁止执行状态更改。
		if (this.state.isQA == false) return

		//获取选中的缺陷记录。
		var checkedDefects = this.state.filteredDefects.filter(t => t.checked)

		//如果没有勾选的缺陷记录，获取当前选中的缺陷记录。
		if (checkedDefects.length == 0) {
			var selectedDefect = this.state.filteredDefects.find(t => t._id.$oid == this.state.selectedDefectId)
			checkedDefects = [selectedDefect]
		}

		if (this.debug) console.log('checkedDefects', checkedDefects)

		checkedDefects.forEach(t => {
			t.checked = false
			t.status = status

			var id = t._id.$oid

			getDefectRequest(this.state.batchId)
				.modifyById(id, {
					status: status,
				})
				.then(res => {
					console.log('修改成功.', t)
				})
				.finally(() => {
					//修改本地的缺陷记录状态。
					var index = this.state.defects.findIndex(p => p._id.$oid == id)
					var replaceItem = this.state.defects[index]
					replaceItem.status = status
					this.state.defects.splice(index, 1, replaceItem)
				})
		})

		//更新筛选状态为正在筛选=1。
		this.changeFilterStatus(1)
	},

	/**
	 * 判断角色是否是QA。
	 * @param {*} roles
	 */
	isQA(roles) {
		return roles.indexOf('qa_monitoring_center') > -1 || roles.indexOf('qa_workstation') > -1 || roles.indexOf('filter_operator') > -1 || roles.indexOf('detection_operator') > -1
	},

	/**
	 * 初始化。
	 * @param {*} batch_id
	 * @param {*} role
	 */
	async initAsync(batch_id, role, userInfo) {
		this.state.batchId = batch_id
		this.state.roles = role.split(',')
		this.state.userInfo = userInfo
		this.state.isQA = this.isQA(this.state.roles)

		await this.getBatchInfo()
		await this.getRollModel()
		await this.getJTInfo()
		await this.getProductInfo()
		await this.loadDefects()
		await this.getDefectTypes()
	},
}
